<div class="msg-sent-container"  [style.background-color]="backgroundColor">
  <i class="fa-light {{icon}}" [style.color]="iconColor"></i>
  <span class="msg-sent">
    {{text}}
  </span>
</div>
